export default __webpack_public_path__ + "static/media/14-constraint-brainstorming.8f2a61d0.svg";